// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Deliveries_componentWrapper__+JkJg","filtersWrapper":"Deliveries_filtersWrapper__629bV"};